<template>
  <section class="panel">
    <div class="panel-header"><h1>注册用户</h1><button @click="loadUsers">刷新</button></div>
    <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    <p v-else-if="loading">加载中...</p>
    <table v-else>
      <thead><tr><th>头像</th><th>姓名</th><th>性别</th><th>手机号码</th><th>注册时间</th></tr></thead>
      <tbody>
        <tr v-for="user in pagedUsers" :key="user.id">
          <td><img v-if="user.avatarUrl" :src="user.avatarUrl" alt="用户头像" class="avatar"><span v-else>-</span></td>
          <td>{{ user.name }}</td><td><span :class="['gender', user.gender === 'female' ? 'female' : 'male']">{{ user.gender === 'female' ? '♀ 女' : '♂ 男' }}</span></td><td>{{ user.phone }}</td><td>{{ formatDate(user.createdAt) }}</td>
        </tr>
        <tr v-if="users.length === 0"><td colspan="5" class="empty">暂无注册用户</td></tr>
      </tbody>
    </table>
    <el-pagination v-if="!loading && !errorMessage" class="pagination" background layout="total, prev, pager, next" :total="users.length" :page-size="pageSize" :current-page.sync="page" />
  </section>
</template>

<script>
import request from '@/api/request';

export default {
  data() { return { users: [], page: 1, pageSize: 10, loading: true, errorMessage: '' }; },
  computed: { pagedUsers() { const start = (this.page - 1) * this.pageSize; return this.users.slice(start, start + this.pageSize); } },
  created() { this.loadUsers(); },
  methods: {
    async loadUsers() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const result = await request.get('/users');
        this.users = result.data.list;
      } catch (error) {
        this.errorMessage = error.response && error.response.data ? error.response.data.message : '无法加载用户列表';
        if (error.response && error.response.status === 401) this.$router.replace('/login');
      } finally { this.loading = false; }
    },
    formatDate(value) { return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '-'; }
  }
};
</script>

<style scoped>
.panel { padding: 28px; background: #fff; border: 1px solid #e0e8e3; }
.panel-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
h1 { margin: 0; font-size: 22px; font-weight: 500; }
button { border: 0; padding: 8px 14px; color: #fff; background: #1f6f50; border-radius: 4px; cursor: pointer; }
table { width: 100%; border-collapse: collapse; text-align: left; }
th, td { padding: 12px; border-bottom: 1px solid #e7eeea; font-size: 14px; }
th { color: #587066; font-weight: 500; background: #f6f9f7; }
.avatar { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; vertical-align: middle; }
.gender { display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 12px; font-size: 13px; }
.gender.male { color: #4f78a7; background: #e7eff7; }
.gender.female { color: #bd667d; background: #f8e8ed; }
.empty { padding: 36px; text-align: center; color: #718079; }
.error { color: #c33; }
.pagination { margin-top: 20px; }
</style>
